import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'errors',
  template: `
    <ul class="errList" *ngIf="showErrors()">
      <li style="color: red;font-size:14px" *ngFor="let error of errors()">{{error}}</li>
    </ul>
  `,
})
export class ErrorsComponent {

  errorMessages: any;
  // static translate: any;
  constructor(private translate: TranslateService) { 

  this.errorMessages = {
    // 'required': () => 'This field is required',
    'required': () => '',
    'minlength': (params) => this.translate.instant('MinlengthError') + ' ' + params.requiredLength,
    'maxlength': (params) => this.translate.instant('MaxLengthError') + ' ' + params.requiredLength,
    'pattern': (params) => '',
    // 'pattern': (params) => 'Invalid Pattern ',
    'age': (params) => params.message,
    'vaildEmail': (params) => params.message,
    'isNum': (params) => params.message,
    'isNegative': (params) => params.message,
  };
}

  @Input()
  private control: AbstractControlDirective | AbstractControl;

  showErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched);
  }

  errors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field]));
  }

  private getMessage(type: string, params: any) {
    return this.errorMessages[type](params);
  }

}